import { render } from "./questions.vue?vue&type=template&id=c07b5734&scoped=true"
import script from "./questions.vue?vue&type=script&lang=js"
export * from "./questions.vue?vue&type=script&lang=js"

import "./questions.vue?vue&type=style&index=0&id=c07b5734&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c07b5734"]])

export default __exports__